import { api } from 'api';
import type { Discount } from 'types/Discount';
import type { List } from 'types/List';
import { Url } from 'utils/constants';

export const getAvailableDiscounts = ({
  countryId,
  pointOfSaleId,
  menuMasterIds,
  date,
}: {
  countryId: string;
  pointOfSaleId: string;
  menuMasterIds: string[];
  date?: string;
}): Promise<List<Discount>> =>
  api.get(
    `${Url.KITCHEN_MANAGEMENT_API_URL}/ccp/countries/${countryId}/point-of-sales/${pointOfSaleId}/discounts`,
    {
      params: {
        menuMasterId: menuMasterIds,
        date,
      },
    }
  );
